<section class="grid-container">
  <tabs (tabClicked)="onTabClicked()">
    <tab title="Bonding">
      <fa-bonding [orgId]="orgId" [externalView]="false" [isRecalculating]="isRecalculating" [isLoading]="isLoading" [complianceDetails]="complianceDetails" (recalculateEvent)="recalculate($event)"></fa-bonding>
    </tab>
    <tab title="Insurance">
      <fa-insurance [orgId]="orgId" [externalView]="false" [isRecalculating]="isRecalculating" [isLoading]="isLoading" [complianceDetails]="complianceDetails" (recalculateEvent)="recalculate($event)"></fa-insurance>
    </tab>
    @if (activeFinancialStatement) {
      <tab title="Financial Statement Management">
        <fa-statement-management [orgId]="orgId" [externalView]="false" [faSummary]="faSummary"></fa-statement-management>
      </tab>
    }
    <tab title="Pending">
      <fa-pending [orgId]="orgId" [isInternal]="true"></fa-pending>
    </tab>
  </tabs>
</section>